export const OPEN_USER_PREVIEW = 'OPEN_USER_PREVIEW';
export const CLOSE_USER_PREVIEW = 'CLOSE_USER_PREVIEW';
